// src/hooks/useIsMobile.js
import { useState, useEffect } from "react";

export default function useIsMobile() {
  const getIsMobile = () =>
    /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth < 769;

  const [isMobile, setIsMobile] = useState(getIsMobile);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(getIsMobile());
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
}